import React, {useState, useEffect} from 'react';
import './App.css';
import ProjectDetails from './ProjectDetails';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

function App() {
  const [data,setData]=useState([]);
  const [options,setOptionsData]=useState<string[]>(['']);
  const [chosenOption, setOption] = useState<string>('');
  const getData=()=>{
    fetch('details.json'
    ,{
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       }
    }
    )
      .then(function(response){
        return response.json();
      })
      .then(function(myJson) {
        const projectsList: string[] = ['',...Object.keys(myJson)];
        setOptionsData(projectsList)
        setData(myJson)
      });
  }
  useEffect(()=>{
    getData()
  },[])

  
  let projectDetailsElem = <span></span>;
  if(chosenOption !== ''){
  //@ts-ignore
    const projectDetails = data[chosenOption];
  //@ts-ignore
    projectDetailsElem = <ProjectDetails project={projectDetails} name={chosenOption}></ProjectDetails>;
  }


  return (
    <div className="App">
      <Dropdown options={options} onChange={(selectedOption) => {
        setOption(selectedOption.value);
      }} value={chosenOption} placeholder="Select a project"  className="form-select"/>
      <br/>
      {projectDetailsElem}
    </div>
  );
}

export default App;
